import styled from 'styled-components';
import Scroll from 'react-indiana-drag-scroll';

import { thinScrollbar } from '../../styles/mixins';

const Container = styled.section`
  width: 100%;
  margin-top: 6rem;

  h2 {
    font-size: 2.6rem;
    font-weight: 700;
    margin-bottom: 2.4rem;
  }
`;

const ProjectsContainer = styled(Scroll)`
  ${thinScrollbar}
  display: flex;
  gap: 2.2rem;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 1rem;
  scroll-snap-type: x proximity;

  > div {
    min-width: 26rem;
    max-width: 26rem;
    white-space: normal;
    scroll-snap-align: start;
  }

  @media (max-width: 760px) {
    gap: 1.4rem;

    > div {
      min-width: 22rem;
      max-width: 22rem;
    }
  }
`;

export { Container, ProjectsContainer };
